<template>
  <div>
    <el-form-item label="原始参数名称">
      <el-select v-model="ruleForm.dataName" placeholder="请选择" @change="updateData">
        <el-option label="id" value="id"></el-option>
        <el-option label="gmid" value="gmid"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="比例">
      <el-input v-model="ruleForm.data" placeholder="" @change="updateData"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "PercentageRule",
  props: {
    rule: {
      type: Object,
      default() {
        return {
          dataName: "",
          data: "",
        }
      }
    }
  },
  data() {
    return {
      ruleForm: this.rule,
    }
  },
  methods: {
    updateData() {
      this.$emit("change", this.ruleForm)
    }
  }
}
</script>

<style scoped>

</style>
